// src/admin/components/RequireAdmin.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {
  clearAdminSession,
  getAdminMe,
  hasAdminSession,
  setAdminSession,
  getAdminToken,
  getAdminExpiresAt,
} from "../adminAuth";
import { adminMeApi } from "../../api/adminAuthApi";

function FullPageLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-white">
      <div className="text-center">
        <div className="text-sm font-semibold text-slate-900">Checking admin access…</div>
        <div className="mt-1 text-sm text-slate-500">
          Please wait while your session is verified.
        </div>
      </div>
    </div>
  );
}

export default function RequireAdmin({ children }) {
  const [state, setState] = useState(() => {
    if (!hasAdminSession()) return "unauthorized";
    return "checking";
  });

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      try {
        const me = await adminMeApi();

        if (cancelled) return;

        const token = getAdminToken();
        const expiresAt = getAdminExpiresAt();
        setAdminSession(token, me, expiresAt);

        if (me?.status !== "ACTIVE") {
          clearAdminSession();
          setState("unauthorized");
          return;
        }

        setState("ok");
      } catch {
        if (cancelled) return;
        clearAdminSession();
        setState("unauthorized");
      }
    }

    if (state === "checking") {
      verify();
    }

    return () => {
      cancelled = true;
    };
  }, [state]);

  if (state === "checking") return <FullPageLoader />;
  if (state !== "ok" || !getAdminMe()) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}